module.exports = __webpack_public_path__ + "img/shengqi.a402e141.png";